import { parseVersionPayload } from './version-check'

export async function fetchVersion(): Promise<number | null> {
  try {
    const res = await fetch('/version.json', { cache: 'no-store' })
    if (!res.ok) return null
    const data: unknown = await res.json()
    return parseVersionPayload(data)
  } catch {
    return null
  }
}
